module.exports = __webpack_public_path__ + "img/485d200.png";